import { connect } from 'react-redux';

import {
  actionGetSettingCoin,
  actionUpdateSettingCoin,
} from 'store/manageCoin/actions';

import ConversionPolicy from './ConversionPolicy';

const mapStateToProps = (state) => ({
  settingCoin: state.ManageCoin.settingCoin,
  isLoadingGetSettingCoin: state.ManageCoin.isLoadingGetSettingCoin,
  isLoadingUpdateSettingCoin: state.ManageCoin.isLoadingUpdateSettingCoin,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetSettingCoin: (payload) => dispatch(actionGetSettingCoin(payload)),
  actionUpdateSettingCoin: (payload) => dispatch(actionUpdateSettingCoin(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ConversionPolicy);
